import { LanguageReq, LanguageResp, TranslationKeyReq, TranslationKeyResp, TranslationValueReq, TranslationValueResp } from '../types/language';
import { useAxios } from '../../hooks/useAxios';

interface ApiResponse<T> {
  status: string;
  data: T;
  errors: any;
}

interface TranslationsResponse {
  [key: string]: string;
}

export interface TranslationExportData {
  languages: LanguageResp[];
  keys: TranslationKeyResp[];
  values: TranslationValueResp[];
}

export interface RoleUserDto {
  userId: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
}

export interface RightCreateReq {
  name: string;
  description: string;
}

export interface RightResp {
  id: number;
  name: string;
  description: string;
}

export const useAdminApi = () => {
  const axios = useAxios();

  return {
    // LANGUAGES
    listLanguages: () => axios.get<ApiResponse<LanguageResp[]>>('/api/admin/get/languages'),
    createLanguage: (data: LanguageReq) => axios.post<ApiResponse<LanguageResp>>('/api/admin/save/language', data),
    updateLanguage: (id: number, data: LanguageReq) => axios.put<ApiResponse<LanguageResp>>(`/api/admin/update/language/${id}`, data),
    deleteLanguage: (id: number) => axios.delete(`/api/admin/delete/language/${id}`),

    // TRANSLATION KEYS
    listKeys: () => axios.get<ApiResponse<TranslationKeyResp[]>>('/api/admin/get/translations/keys'),
    createKey: (data: TranslationKeyReq) => axios.post<ApiResponse<TranslationKeyResp>>('/api/admin/save/translations/keys', data),
    updateKey: (id: number, data: TranslationKeyReq) => axios.put<ApiResponse<TranslationKeyResp>>(`/api/admin/update/translations/keys/${id}`, data),
    deleteKey: (id: number) => axios.delete(`/api/admin/delete/translations/keys/${id}`),

    // TRANSLATION VALUES
    listValues: () => axios.get<ApiResponse<TranslationValueResp[]>>('/api/admin/get/translations/values'),
    upsertValue: (data: TranslationValueReq) => axios.post<ApiResponse<TranslationValueResp>>('/api/admin/set/translations/values', data),
    deleteValue: (id: number) => axios.delete(`/api/admin/delete/translations/values/${id}`),

    // TRANSLATIONS
    getTranslations: (lang: string) => axios.get<ApiResponse<Record<string, string>>>(`/api/admin/get/lang/translations?lang=${lang}`),
    updateTranslations: (lang: string, translations: TranslationsResponse) => axios.post<ApiResponse<void>>('/api/admin/update/translations', { lang, translations }),
    // EXPORT TRANSLATIONS
    exportTranslations: () => axios.get<ApiResponse<TranslationExportData>>('/api/admin/translations/export'),

    // IMPORT TRANSLATIONS
    importTranslations: (data: TranslationExportData) => axios.post<ApiResponse<void>>('/api/admin/translations/import', data),

    // ROLE MANAGEMENT
    getAllRoles: () => axios.get<ApiResponse<string[]>>('/api/admin/roles'),
    createRole: (roleName: string) => axios.post<ApiResponse<string>>('/api/admin/role/create', null, { params: { roleName } }),
    deleteRole: (roleName: string) => axios.delete<ApiResponse<string>>(`/api/admin/role/delete?roleName=${roleName}`),
    assignRoleToUser: (userId: string, roleName: string) => axios.post<ApiResponse<string>>(`/api/admin/roles/assign?userId=${userId}&roleName=${roleName}`),
    revokeRoleFromUser: (userId: string, roleName: string) => axios.post<ApiResponse<string>>(`/api/admin/roles/revoke?userId=${userId}&roleName=${roleName}`),
    getUsersByRole: (roleName: string) => axios.get<ApiResponse<RoleUserDto[]>>(`/api/admin/roles/users?roleName=${roleName}`),

    // RIGHT İŞLEMLERİ
    createRight: (data: RightCreateReq) => axios.post<ApiResponse<string>>('/api/admin/role-rights/create/right', data),
    getAllRights: () => axios.get<ApiResponse<RightResp[]>>('/api/admin/role-rights/rights'),
    // ROL-RIGHT ATAMA
    assignRightToRole: (roleName: string, rightName: string) => axios.post<ApiResponse<string>>(`/api/admin/role-rights/assign?roleName=${roleName}&rightName=${rightName}`),
    getRightsByRole: (roleName: string) => axios.get<ApiResponse<string[]>>(`/api/admin/role-rights/get/rights/${roleName}`),
    deleteByRoleName: (roleName: string) => axios.delete<ApiResponse<string>>(`/api/admin/role-rights/right/delete/${roleName}`),
    updateRight: (roleName: string, data: RightCreateReq) => axios.put<ApiResponse<RightResp>>(`/api/admin/role-rights/right/update/${roleName}`, data),
    revokeRightFromRole: (roleName: string, rightName: string) => axios.delete<ApiResponse<string>>(`/api/admin/role-rights/revoke?roleName=${roleName}&rightName=${rightName}`),

  };
};